/**
 * Interface for the 'ShipmentPackages' data
 */
import {Portals} from '@qwyk/models';

export interface ShipmentPackage {
    id: number; // Primary ID
    quantity: number;
    packaging: Packaging;
    description: string;
    weight: number;
    volume: number;
    uom: 'metric' | 'imperial';
    product_id?: string;
    product_sku?: string;
    product_name?: string;
    po_number?: string;
    po_line?: string;
    po_id?: string;
    hs_code?: string;
    un_code?: string;
    length: Portals.MultiUnitValue | null;
    width: Portals.MultiUnitValue | null;
    height: Portals.MultiUnitValue | null;
    notes: string | null;
    cargo_releases: Portals.CargoItemParent[];
    pickup_orders: Portals.CargoItemParent[];
    warehouse_receipts: Portals.CargoItemParent[];
}

export interface Packaging {
    id: number;
    description: string;
    description_plural?: string;
}
